<div class="modal-header">
  <h5 class="modal-title">Alerts &amp; Announcements</h5>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body important-modal">
  <app-notification-card
    *ngFor="let item of items"
    [item]="item"
    variant="page"
    [attachments]="getAttachments(item)"
    [categoryLabel]="categoryLabel(item.category)"
    [categoryIconName]="categoryIcon(item.category)"
    [priorityLabel]="priorityLabel(item.priority)"
    [relativeTimeLabel]="relativeTime(item.createdAt)"
    (cardClick)="onCardClick(item)"
    (markReadClick)="markRead(item)"
    (previewAttachment)="openAttachmentPreview($event)"
    (downloadAttachment)="downloadAttachmentFile($event)">
  </app-notification-card>
  <p *ngIf="!items.length" class="text-muted mb-0">No new alerts or announcements.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="dismiss()">Dismiss</button>
  <button type="button" class="btn btn-primary" (click)="markAllRead()">Mark all read</button>
</div>
